import { BookOpen, Music2, Sparkles } from 'lucide-react';

export function HomeScreen({onStart,onTeacher,onHelp}:{onStart:()=>void;onTeacher:()=>void;onHelp:()=>void}){
  return <main className="home screen">
    <div className="music-orb" aria-hidden="true"><span>♪</span><i/><b/></div>
    <section className="hero">
      <p className="eyebrow">AI 音樂律動小幫手</p>
      <h1>看得見的音樂</h1>
      <p className="subtitle">聽音樂・動身體・看見你的音樂</p>
      <div className="home-actions">
        <button className="big-button primary" onClick={onStart}><Sparkles/>開始律動</button>
        <button className="big-button" onClick={onTeacher}><Music2/>老師模式</button>
        <button className="big-button soft" onClick={onHelp}><BookOpen/>使用說明</button>
      </div>
    </section>
    <p className="privacy-chip">🔒 影像只在這部 iPad 處理</p>
  </main>;
}
